export enum Cookies {
    Session = 'f24_session',
}
